import { render } from "./GastosView.vue?vue&type=template&id=4661e749"
import script from "./GastosView.vue?vue&type=script&lang=js"
export * from "./GastosView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__